





























































































































































































































































import { validLicensePlate } from '../custom-validators'
import { SEGMENT_EVENTS, trackEvent } from '@/analytics/segment'

export default {
  props: {
    vehicleTypes: {
      type: Array,
      required: true
    },
    companyDetails: {
      type: Object,
      required: true
    },
    isSubmitting: { type: Boolean, default: false }
  },
  data: () => ({
    form: {
      originCompany: '',
      originAddress: '',
      pickupDate: '',
      pickupTimeStart: '',
      pickupTimeEnd: '',
      destinationCompany: '',
      destinationAddress: '',
      deliveryDate: '',
      deliveryTimeStart: '',
      deliveryTimeEnd: '',
      vehicleType: 'TRUCK_40_TAUTLINER',
      vehicleLicensePlate: '',
      trailerLicensePlate: '',
      transportNumber: '',
      customerName: '',
      customerVat: '',
      basePrice: null
    }
  }),
  computed: {
    requiredValidator() {
      return {
        errorMessage: this.$t('myTransports.registrationForm.errorMsg.required'),
        isInvalid: input => !input.length
      }
    },
    licencePlateValidator() {
      return {
        errorMessage: this.$t('myTransports.registrationForm.errorMsg.licensePlate'),
        isInvalid: input => !validLicensePlate(input)
      }
    },
    truckTypeValue: {
      get() {
        return this.form.vehicleType
          ? this.vehicleTypes.find(option => option.id === this.form.vehicleType)
          : ''
      },
      set(value) {
        this.form.vehicleType = value?.id || null
      }
    }
  },
  methods: {
    maxLengthValidator(length) {
      return {
        errorMessage: this.$t('myTransports.registrationForm.errorMsg.maxLength', {
          count: length
        }),
        isInvalid: input => input.length > length
      }
    },
    submit(event) {
      if (!event.hasErrors) {
        trackEvent(SEGMENT_EVENTS.TRANSPORT_REGISTRATION_SUBMIT)
        this.$emit('submit', this.form)
      }
    }
  }
}
